import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { EducationFormValues } from "./interface";

interface EditFieldsProps {
  formValues: EducationFormValues;
  handleChange: (
    field: keyof EducationFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        multiline
        label="Special Education Services & IEP"
        value={formValues.specialEducationServices}
        onChange={handleChange("specialEducationServices")}
      />
    </Grid>
  );
};

export default EditFields;
